<template>
  <div id="ticketing-step-0" v-if="step === 1">
    <div class="ticketing-content">
      <div class="seat-selection">
        <div class="legend">
          <div>
            <span class="selected"></span>
            <p>Ghế bạn chọn</p>
          </div>
          <div>
            <span class="unavailable"></span>
            <p>Không thể chọn</p>
          </div>
          <div>
            <span class="seat-area-1 taken"></span>
            <p>Đã bán</p>
          </div>
        </div>

        <span class="front">Màn hình</span>

        <div class="text-center" v-if="seats.rows.length === 0">
          <div class="spinner-border d-block m-auto" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="text-muted mt-2" v-html="'Đang tải dữ liệu ghế.<br />Vui lòng chờ trong giây lát...'"></p>
        </div>

        <div class="seats-wrapper-parent">
          <div class="seats-wrapper">
            <div class="seats-wrapper-row">
              <div class="seats seats-row">
                <div class="row-wrapper">
                  <ul class="seat-row" v-for="row in seats.rows" :key="row">
                    <li class="rowname wide">{{ row }}</li>
                  </ul>
                </div>
              </div>
              <div class="seats seats-map">
                <div class="row-wrapper">
                  <ul class="seat-row" v-for="(rows, rowIndex) in seats.seats" :key="rowIndex">
                    <template v-for="seat in rows" :key="seat.id">
                      <li v-if="seat && seat.id"
                          :class="[seat.taken ? 'taken' : 'available', 'seat-area-' + seat.category.id, 'seat-size-' + seat.size, seat.picked ? 'selected' : '', seat.group !== null ? 'seat-group' : '', seat.index % 2 === 0 ? 'seat-odd' : 'seat-even' ]"
                          @click="onSeatClick(seat)">
                        {{ seat.name }}
                      </li>
                      <li v-else class="spacer"></li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="legend mt-4">
          <div v-for="category in seats.categories" :key="category.id">
            <span :class="'seat-area-' + category.id"></span>
            <p>{{ category.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  step: {
    type: Number,
    required: true
  },
  seats: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['seat-click'])

const onSeatClick = (seat) => {
  emit('seat-click', seat)
}
</script> 